import EDC from '@/components/games/shared/globals';
import router from '@/router';
import store from '@/store';

/**
 *
 */
EDC.Games.GameKickoff.Scenes.Preloader = function () {};
/**
 *
 */
EDC.Games.GameKickoff.Scenes.Preloader.prototype.create = function () {
  const gameId = router.currentRoute.params.id;
  const gameConfig = store.getters['games/getGameById'](gameId);

  this.load.on('complete', this.onLoadImagesComplete, this);
  this.load.setPath('https://s3.amazonaws.com/images.growmindgrow/phaser-assets/');

  const preview = gameConfig?.preview;
  this.load.image('thumbnail_image', `previews/${preview}`);
  this.load.image('background', 'images/views/GameKickoff/Background.jpg');
  this.load.image('btn_continue_arrow', 'images/views/GameKickoff/arrow_continue.png');
  this.load.image('btn_continue_frame', 'images/views/GameKickoff/btn_continue_frame.png');
  this.load.image('btn_continue_frame_hover', 'images/views/GameKickoff/btn_continue_frame_hover.png');
  this.load.image('btn_continue_text', 'images/views/GameKickoff/btn_continue_text.png');
  this.load.image('btn_back_arrow', 'images/views/GameKickoff/arrow_back.png');
  this.load.image('btn_back_frame', 'images/views/GameKickoff/btn_small.png');
  this.load.image('btn_back_frame_hover', 'images/views/GameKickoff/btn_small_hover.png');
  this.load.image('btn_back_text', 'images/views/GameKickoff/change_text.png');
  this.load.image('grade_1', 'images/views/GameKickoff/grade_1.png');
  this.load.image('grade_2', 'images/views/GameKickoff/grade_2.png');
  this.load.image('grade_3', 'images/views/GameKickoff/grade_3.png');
  this.load.image('grade_4', 'images/views/GameKickoff/grade_4.png');
  this.load.image('grade_5', 'images/views/GameKickoff/grade_5.png');
  this.load.image('grade_k', 'images/views/GameKickoff/grade_K.png');
  this.load.image('icons_general', 'images/views/GameKickoff/icons_category_globe.png');
  this.load.image('icons_language', 'images/views/GameKickoff/icons_category_language.png');
  this.load.image('icons_mathematics', 'images/views/GameKickoff/icons_category_math.png');
  this.load.image('icons_logic', 'images/views/GameKickoff/icons_category_puzzle.png');
  this.load.image('category_label', 'images/views/GameKickoff/label_category.png');
  this.load.image('grade_label', 'images/views/GameKickoff/label_grade.png');
  this.load.image('level_label', 'images/views/GameKickoff/label_level.png');
  this.load.image('rating_label', 'images/views/GameKickoff/label_myrating.png');
  this.load.image('ratingbar_1', 'images/views/GameKickoff/ratingbar_1.png');
  this.load.image('ratingbar_2', 'images/views/GameKickoff/ratingbar_2.png');
  this.load.image('ratingbar_3', 'images/views/GameKickoff/ratingbar_3.png');
  this.load.image('ratingbar_4', 'images/views/GameKickoff/ratingbar_4.png');
  this.load.image('ratingbar_5', 'images/views/GameKickoff/ratingbar_5.png');
  this.load.image('ratingbar_6', 'images/views/GameKickoff/ratingbar_6.png');
  this.load.image('ratingbar_7', 'images/views/GameKickoff/ratingbar_7.png');
  this.load.image('ratingbar_8', 'images/views/GameKickoff/ratingbar_8.png');
  this.load.image('ratingbar_9', 'images/views/GameKickoff/ratingbar_9.png');
  this.load.image('ratingbar_10', 'images/views/GameKickoff/ratingbar_10.png');
  this.load.image('small_frame', 'images/views/GameKickoff/small_frame.png');
  this.load.image('star_empty', 'images/views/GameKickoff/star_empty.png');
  this.load.image('star_full', 'images/views/GameKickoff/star_full.png');
  this.load.image('stats_frame', 'images/views/GameKickoff/stats_frame.png');
  this.load.image('thumbnail_frame', 'images/views/GameKickoff/thumbnail_frame.png');
  this.load.image('title', 'images/views/GameKickoff/title.png');
  this.load.image('title_frame', 'images/views/GameKickoff/title_frame.png');
  this.load.image('logo', 'images/OrbUp_Logo.png');

  this.load.setPath();
  this.load.start();
};
/**
 *
 */
EDC.Games.GameKickoff.Scenes.Preloader.prototype.onLoadImagesComplete = function () {
  this.load.off(this.onLoadImagesComplete, this);
  this.scene.start('main');
};

export default EDC.Games.GameKickoff.Scenes.Preloader;
